<script setup lang="ts">
import JoinContest from "@/components/JoinContest.vue";
import AgeVerification from "@/components/AgeVerification.vue";
import {onMounted, ref} from "vue";
import DesktopInfo from "@/components/DesktopInfo.vue";

const isAdult = ref(false);
const checkAge = (userAge: number) => {
  isAdult.value = !!(userAge && userAge >= 18);
}

onMounted(() => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const showHome = urlParams.get('showHome');

  if(showHome === 'true') {
    isAdult.value = true;
  }

})
</script>

<template>
  <main>
      <div class="hidden lg:block">
        <DesktopInfo></DesktopInfo>
      </div>
      <div class="block lg:hidden">
          <JoinContest v-if="isAdult"></JoinContest>
          <AgeVerification v-else  @ageVerified="checkAge"></AgeVerification>
      </div>
  </main>
</template>
